export default __webpack_public_path__ + "static/eat-pray-money-846035e3860cc9debb0866a03c7833c4.gif";